<template>
  <div class="invoice-item">
    <router-link :to="`/order/invoice/${item.id}`" tag="div">
      <div class="invoice-top">
        <p>发货单号：{{ item.outbound_numeber }}</p>
        <p>
          实付款：<span class="price">￥{{ item.paid }}</span>
        </p>
      </div>
      <div class="invoice-middle">
        <div class="invoice-img-list">
          <img
            class="invoice-img"
            v-for="good in item.goods.slice(0, 3)"
            :key="good.id"
            v-lazy="good.image"
          />
          <i class="invoice-tips"> 共{{ item.goods_num }}件 </i>
        </div>
      </div>
    </router-link>
    <div class="invoice-bottom">
      <p>关联单号：{{ item.order_number.toString() }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'invoice-item',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.invoice {
  &-item {
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid $border-color-base;
    border-left: 0;
    border-right: 0;
    box-shadow: $box-shadow-base;
    margin-bottom: 8px;
  }
  &-top {
    @include flex(row);
    padding-bottom: 12px;
    border-bottom: 1px solid $border-color-base;
    justify-content: space-between;
    font-size: 12px;
    color: $heading-color;
    font-weight: 700;
    .price {
      color: #EB1F1F;
      font-weight: 700;
    }
  }
  &-middle {
    padding: 15px 0;
    border-bottom: 1px solid $border-color-base;
    @include flex(row);
    align-items: center;
    .invoice-tips {
      width: 60px;
      height: 60px;
      background: #EEEEEE;
      color: #777777;
      font-size: 12px;
      float: right;

      @include center(row)
    }
  }
  &-bottom {
    padding-top: 10px;
    font-size: 11px;
  }
  &-img {
    width: 60px;
    height: 60px;
    border: 1px solid $border-color-base;
    margin-right: 25px;
    &-list {
      width: 100%;
    }
  }
}
</style>
